
import path from 'path'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Route, RouteConfig } from 'vue-router'
import { isExternal } from '@/utils/validate'
import SidebarItemLink from './SidebarItemLink.vue'

@Component({
  // Set 'name' here to prevent uglifyjs from causing recursive component not work
  // See https://medium.com/haiiro-io/element-component-name-with-vue-class-component-f3b435656561 for detail
  name: 'SidebarItem',
  components: {
    SidebarItemLink
  }
})
export default class extends Vue {
  @Prop({ required: true }) private item!: RouteConfig
  @Prop({ default: false }) private isCollapse!: boolean
  @Prop({ default: true }) private isFirstLevel!: boolean
  @Prop({ default: '' }) private basePath!: string
  @Prop({ default: '' }) private taskCenter!: {}

  get count() {
    let count: number = 0
    const taskCenter: any = this.taskCenter
    switch (this.item.path) {
      case 'applicationTask':
        count = taskCenter.application_count
        break
      case 'withdrawReview':
        count = taskCenter.withdraw_review_count
        break
      case 'antReview':
        count = taskCenter.trc20_payout_count
        break
      case 'exceptionTask':
        count = taskCenter.exception_count
        break
      case 'subAccount':
        count = taskCenter.upi_in_review_count
        break
      case 'depositReview':
        count = taskCenter.deposit_review_count
        break
      case 'refund':
        count = taskCenter.refund_review_count
        break
      case 'requestLog':
        count = taskCenter.api_log_count
        break
      case 'rechargeCurrency':
        count = taskCenter.buy_usdt_task_count
        break
      case 'cashOrder':
        count = taskCenter.ant_withdraw
        break
      case 'antOrderReview':
        count += taskCenter.ant_review
        break
      case 'antRegister':
        count += taskCenter.ant_register_count
        break
      case 'accessDevice':
        count += taskCenter.manage_count
        break
      case '/task':
        // eslint-disable-next-line no-case-declarations
        const childRouters = this.item.children
        childRouters?.forEach((item: RouteConfig) => {
          switch (item.path) {
            case 'applicationTask':
              count += taskCenter.application_count
              break
            case 'withdrawReview':
              count += taskCenter.withdraw_review_count
              break
            case 'exceptionTask':
              count += taskCenter.exception_count
              break
            case 'depositReview':
              count += taskCenter.deposit_review_count
              break
            case 'refund':
              count += taskCenter.refund_review_count
              break
            case 'antOrderReview':
              count += taskCenter.ant_review
              break
            case 'antRegister':
              count += taskCenter.ant_register_count
              break
          }
        })
        break
      case '/product':
        // eslint-disable-next-line no-case-declarations
        const productRouters = this.item.children
        productRouters?.forEach((item: RouteConfig) => {
          switch (item.path) {
            case 'rechargeCurrency':
              count += taskCenter.buy_usdt_task_count
              break
            case 'exceptionTask':
              count += taskCenter.exception_count
              break
            case 'subAccount':
              count += taskCenter.upi_in_review_count
              break
          }
        })
        break
      case '/order':
        // eslint-disable-next-line no-case-declarations
        const refundChildRouters = this.item.children
        refundChildRouters?.forEach((item: RouteConfig) => {
          switch (item.path) {
            case 'refund':
              count += taskCenter.refund_review_count
              break
            case 'requestLog':
              count += taskCenter.api_log_count
              break
            case 'cashOrder':
              count += taskCenter.ant_withdraw
              break
          }
        })
        break
      case '/manager':
        // eslint-disable-next-line no-case-declarations
        const managerChildRouters = this.item.children
        managerChildRouters?.forEach((item: RouteConfig) => {
          switch (item.path) {
            case 'accessDevice':
              count += taskCenter.manage_count
              break
          }
        })
      // eslint-disable-next-line no-fallthrough
      default:
        break
    }
    return count
  }
  get showBadge() {
    if (
      this.item.path === 'applicationTask' ||
      this.item.path === 'withdrawReview' ||
      this.item.path === 'antReview' ||
      this.item.path === 'exceptionTask' ||
      this.item.path === 'subAccount' ||
      this.item.path === 'depositReview' ||
      this.item.path === 'rechargeCurrency' ||
      this.item.path === '/task' ||
      this.item.path === '/order' ||
      this.item.path === 'refund' ||
      this.item.path === 'requestLog' ||
      this.item.path === 'cashOrder' ||
      this.item.path === '/product' ||
      this.item.path === 'antOrderReview' ||
      this.item.path === '/manager' ||
      this.item.path === 'accessDevice'||
      this.item.path === 'antRegister'
    ) {
      return true
    }
    return false
  }
  get alwaysShowRootMenu() {
    if (this.item.meta && this.item.meta.alwaysShow) {
      return true
    }
    return false
  }

  get showingChildNumber() {
    if (this.item.children) {
      const showingChildren = this.item.children.filter(item => {
        if (item.meta && item.meta.hidden) {
          return false
        } else {
          return true
        }
      })
      return showingChildren.length
    }
    return 0
  }

  get theOnlyOneChild() {
    if (this.showingChildNumber > 1) {
      return null
    }
    if (this.item.children) {
      for (let child of this.item.children) {
        if (!child.meta || !child.meta.hidden) {
          return child
        }
      }
    }
    // If there is no children, return itself with path removed,
    // because this.basePath already conatins item's path information
    return { ...this.item, path: '' }
  }

  private resolvePath(routePath: string) {
    if (isExternal(routePath)) {
      return routePath
    }
    if (isExternal(this.basePath)) {
      return this.basePath
    }
    return path.resolve(this.basePath, routePath)
  }
}
